import {styled} from "styled-components";

export const TableItem = styled.div`
    height: 48px;
    display: flex;
    align-items: center;
`
